import { NgModule } from '@angular/core'; 
import { BrowserModule } from '@angular/platform-browser'; 

import { ExecutiveJobsComponent } from './pages/executive-jobs/executive-jobs.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { HomeSlidersComponent } from './components/home-sliders/home-sliders.component';
import { NavComponent } from './components/nav/nav.component';
import { FooterComponent } from './components/footer/footer.component';
import { LatestNewsComponent } from './components/latest-news/latest-news.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { NavPagesComponent } from './partials/nav-pages/nav-pages.component';
import { CsrComponent } from './pages/csr/csr.component';
import { WhatWeDoComponent } from './pages/what-we-do/what-we-do.component';
import { UnsungHeroesComponent } from './pages/reach-out/unsung-heroes/unsung-heroes.component';
import { OrphanageVisitComponent } from './pages/reach-out/orphanage-visit/orphanage-visit.component';
import { HospitalityComponent } from './pages/hospitality/hospitality.component';
import { JoinOurTribeComponent } from './pages/join-our-tribe/join-our-tribe.component';

import { JobDescComponent } from './pages/job-desc/job-desc.component';
import { NewsComponent } from './pages/news/news.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { SinglePostComponent } from './partials/single-post/single-post.component';
import { TermsPageComponent } from './pages/terms-page/terms-page.component';
import { LoaderComponent } from './partials/loader/loader.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { LoaderInterceptor } from './interceptors/loader/loader.interceptor';
import { NavRedLogoComponent } from './components/nav-red-logo/nav-red-logo.component';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';
import { FormsModule } from '@angular/forms';
import { LeadershipComponent } from './pages/leadership/leadership.component';

import { CursorService } from './services/cursor_animation/cursor.service';
import { CursorColorService } from './services/cursorColor/cursor-color.service';
import { QueenIdiaComponent } from './pages/queen-idia/queen-idia.component';
import { ElitesComponent } from './pages/elites/elites.component';
import { ProjectsSliderComponent } from './partials/projects-slider/projects-slider.component';

import { CloudinaryModule } from '@cloudinary/ng';
import { ProjectsPageComponent } from './pages/projects-page/projects-page.component';
import { CeoPageComponent } from './partials/ceo-page/ceo-page.component';
import { ReachOutPageComponent } from './pages/reach-out-page/reach-out-page.component';
import { ReachOutSplideComponent } from './partials/reach-out-splide/reach-out-splide.component';
import { LoaderPagesComponent } from './partials/loader-pages/loader-pages.component';
import { FooterSmComponent } from './components/footer/footer-sm/footer-sm.component';
import { NewsletterComponent } from './components/footer/newsletter/newsletter.component';
import { FigmaJourneyCardComponent } from './components/figma-benin-city/figma-journey-card.component';
import { FigmaBeninHeroComponent } from './components/figma-benin-city/figma-benin-hero.component';
import { FigmaBeninStoryComponent } from './components/figma-benin-city/figma-benin-story.component';
import { FigmaBeninRjComponent } from './components/figma-benin-city/figma-benin-rj.component';
import { FigmaBeninCityComponent } from './pages/figma-benin-city/figma-benin-city.component';
import { FigmaBeninNavComponent } from './components/figma-benin-city/figma-benin-nav/figma-benin-nav.component';
import { FigmaBeninFooterComponent } from './components/figma-benin-city/figma-benin-footer/figma-benin-footer.component';

import { CareerListingComponent } from './components/career-listing/career-listing.component';
import { JobSidebarComponent } from './components/job-sidebar/job-sidebar.component';
import { JobDetailInfoComponent } from './components/job-detail-info/job-detail-info.component';

@NgModule({ declarations: [
        AppComponent,
        HomePageComponent,
        HomeSlidersComponent,
        NavComponent,
        FooterComponent,
        LatestNewsComponent,
        AboutUsComponent,
        NavPagesComponent,
        CsrComponent,
        WhatWeDoComponent,
        UnsungHeroesComponent,
        OrphanageVisitComponent,
        HospitalityComponent,
        JoinOurTribeComponent,

        JobDescComponent,
        NewsComponent,
        ContactUsComponent,
        SinglePostComponent,
        TermsPageComponent,
        LoaderComponent,
        PageNotFoundComponent,
        NavRedLogoComponent,
        MaintenanceComponent,
        LeadershipComponent,
        QueenIdiaComponent,
        ElitesComponent,
        ProjectsSliderComponent,
        ProjectsPageComponent,
        CeoPageComponent,
        ReachOutPageComponent,
        ReachOutSplideComponent,
        LoaderPagesComponent,
        FooterSmComponent,
        NewsletterComponent,
        FigmaJourneyCardComponent,
        FigmaBeninHeroComponent,
        FigmaBeninStoryComponent,
        FigmaBeninRjComponent,
        FigmaBeninCityComponent,
        FigmaBeninNavComponent,
        FigmaBeninFooterComponent,

        CareerListingComponent,
        JobSidebarComponent,
        JobDetailInfoComponent,
        ExecutiveJobsComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        CloudinaryModule], providers: [
        CursorColorService,
        CursorService,
        { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class AppModule { }
